import { CACHE_KEY_LIST_HISTORIAN_OFFICES } from '@/modules/configuration/contants/historianOffices';
import HistorianOfficesApiService from '@/modules/configuration/services/HistorianOfficesApiService';
import { createEntityBulkActions } from '@/utils/createEntityBulkActions';

const HistorianOfficesBulkAction = createEntityBulkActions(HistorianOfficesApiService, CACHE_KEY_LIST_HISTORIAN_OFFICES, 'configuration');

export default HistorianOfficesBulkAction;
